import "animate.css";
import { Link } from "react-router-dom";
import ArrowIcon from "../../common/svg/ArrowIcon";

const Contact = () => {
  const text = ["We take care of your IT, So You Can Focus on Your Business."];

  const marqueeItems = text.map((text, index) => (
    <span key={index} className="marquee-item">
      {text}
    </span>
  ));

  return (
    <div className="home3-contact-area">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="contact-wrapper text-center">
              <h2 className="marquee_text">
                <div className="marquee_content">
                  {marqueeItems}
                  {marqueeItems}
                </div>
              </h2>

              <div
                className="contact-btn magnetic-item  wow animate__animated animate__fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <Link to="/contact-us">
                  Contact With Us.
                  <ArrowIcon width={32} height={32} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
